import SystemUpdateAltRoundedIcon from '@mui/icons-material/SystemUpdateAltRounded';
import { Button } from '@mui/material';

interface ExportButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * エクスポートボタンコンポーネント
 */
export const ExportButton = ({ onClick, label }: ExportButtonProps) => {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<SystemUpdateAltRoundedIcon />}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

